module.exports = __webpack_public_path__ + "f93c8677310d63ac91b2626c69f8f7d5.svg";